import * as React from "react";
const SvgPlayArrowOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M10 8.64 15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z" />
  </svg>
);
export default SvgPlayArrowOutlined;
